import Vue from 'vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import { isMobile, toggleGameArea, handleResize, handleScroll } from '@/utils/toggleNavbar.js';
export default Vue.extend({
    name: 'Games',
    // inject: ['checkUrl', 'mapUrl'],
    data() {
        return {
            keywords: '',
            filterMain: [
                { value: 1, key: 'slots', name: this.$t('XIN') },
                { value: 4, key: 'live', name: this.$t('AG') },
                { value: 3, key: 'yp', name: this.$t('YOPLAY') },
                { value: 2, key: 'hunter', name: this.$t('HUNTER') }
            ],
            filterClassNow: [0],
            filterPlatformNow: 0,
            selectedClasses: 'all',
            filterConditionNow: 0,
            filterConditions: [
                { value: 1, key: 'sw', render: this.$t('SUPPORTSW') },
                { value: 2, key: 'jackpot', render: this.$t('JACKPOT') },
                { value: 3, key: 'hot', render: this.$t('HOT') },
                { value: 4, key: 'new', render: this.$t('NEW') },
                { value: 5, key: 'free', render: this.$t('FREEGAME') }
            ],
            filteredList: [],
            // hotList:['SC03', 'SB01', 'SB49', 'FRU', 'SB08', 'WH48', 'SB56', 'FRU2', 'SC07', 'SB57', 'YP848', 'YP814', 'YP823', 'YP810', 'YP825', 'YP840', 'YP841', 'YP843', 'YP811', 'YP827', 'BAC'],
            hotList: ['SC03', 'SB01', 'VG01', 'SB08', 'SB49', 'FRU', 'WH48', 'FRU2', 'VG06', 'SB56', 'YP848', 'YP814', 'YP823', 'YP810', 'YP825', 'YP840', 'YP843', 'YP841', 'YP811', 'YP827', 'BAC'],
            newList: ['KG35', 'HG03', 'VG08', 'VG05', 'KG06', 'KG05', 'MA71', 'HG01', 'YP911', 'YP910', 'YP909', 'VDG', 'UH01'],
            cantList: ['BJ'],
            liveList: { BAC: 'N010', LBAC: 'M090', DT: 'N020', ZJH: 'N021', NN: 'N022', SG: 'N024', SHB: 'N026', ROU: 'D001', VDG: 'X001' },
            cnyList: ['WEBCNY01', 'WEBCNY02', 'WEBCNY03', 'WEBCNY04', 'WEBCNY05', 'WEBCNY06'],
            usdList: ['WEBUSD01', 'WEBUSD02', 'WEBUSD03', 'WEBUSD04', 'WEBUSD05', 'WEBUSD06'],
            diff: '',
            errorMessage: '',
            isGameAreaVisible: true,
            isMobile: isMobile()
        };
    },
    props: ['showGameAreaComputed'],
    computed: {
        ...mapState('common', ['lang']),
        ...mapState('auth', ['isLogin', 'loginUser']),
        ...mapState('games', ['gamesList']),
        translate() {
            const locale = this.$i18n.locale;
            return (key) => {
                const translations = {
                    視訊撲克: 'VP',
                    老虎機: 'SLOTS',
                    桌面遊戲: 'TG',
                    其他: 'OTHER',
                    多人: 'MUPLAYER',
                    單人: 'SINGLEPLAYER',
                    轉盤: 'ROULETTE',
                    棋牌: 'CARD',
                    彩金: 'JACKPOT',
                    真人视讯: 'LIVE',
                    免费局: 'FREEGAME',
                    支援SW: 'SUPPORTSW',
                    热门: 'HOT',
                    最新: 'NEW',
                    电子游戏: 'XIN',
                    捕鱼游戏: 'HUNTER',
                    YOPLAY街机: 'YOPLAY'
                };
                // return translations[key] || key
                // return key.split(',').map(k => translations[k.trim()] || k.trim()).join(', ')
                return key.split(',').map(k => {
                    const raw = k.trim();
                    // 3. 找出對應的 i18n Key，如果 keyMap 沒定義，就直接拿 raw 去翻譯
                    const targetI18nKey = translations[raw] || raw;
                    // 4. 在這裡才執行 $t (關鍵：這樣切換語言才會生效)
                    // te() 是檢查該 key 是否存在的防呆
                    return this.$i18n.te(targetI18nKey) ? this.$t(targetI18nKey) : raw;
                }).join(', ');
            };
        },
        filterClassesDynamic() {
            if (this.filterPlatformNow === 3) {
                // yp
                return [
                    // { value: 1, key: '全部', render: this.$t('ALL') },
                    { value: 2, key: '單人', render: this.$t('SINGLEPLAYER') },
                    { value: 3, key: '多人', render: this.$t('MUPLAYER') },
                    { value: 4, key: '轉盤', render: this.$t('ROULETTE') },
                    { value: 5, key: '棋牌', render: this.$t('CARD') },
                    { value: 6, key: '彩金', render: this.$t('JACKPOT') },
                    { value: 7, key: '其他', render: this.$t('OTHER') }
                ];
            }
            // 其他平台用原本那組
            return [
                { value: 1, key: '視訊撲克', render: this.$t('VP') },
                { value: 2, key: '老虎機', render: this.$t('SLOTS') },
                { value: 3, key: '桌面遊戲', render: this.$t('TG') },
                { value: 4, key: '其他', render: this.$t('OTHER') }
            ];
        },
        platformKey() {
            const selectedPlatform = this.filterMain.find(item => item.value === this.filterPlatformNow);
            // 取出 key（slots、hunter、yp）
            return selectedPlatform?.key || '';
        },
        filteredConditions() {
            if (this.filterPlatformNow === 4) {
                return this.filterConditions.filter(item => item.value !== 5);
            }
            return this.filterConditions;
        }
    },
    async mounted() {
        this.filteredList = await this.getGames();
        this.notifyParent();
        this.resizeHandler = () => handleResize(this);
        this.scrollHandler = () => handleScroll(this);
        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        window.removeEventListener('scroll', this.scrollHandler);
    },
    methods: {
        ...mapMutations('common', ['ChangeDialog']),
        ...mapActions('message', ['setSnackbar']),
        ...mapActions('games', ['getGames', 'setCurrGame']),
        notifyParent() {
            this.$emit('platform-change', this.filterPlatformNow);
        },
        heightClass(item) {
            if (item.platform === 'yp') {
                return 'yp-flip-scene';
            }
            else if (item.platform === 'live') {
                return 'live-flip-scene';
            }
            else if (item.platform === 'hunter') {
                return 'hunter-flip-scene';
            }
            return '';
        },
        gridClass() {
            if (this.filterPlatformNow === 4) {
                return 'live-grid';
            }
            if (this.filterPlatformNow === 2) {
                return 'hunter-grid';
            }
            return '';
        },
        // 也需檢查
        async search(val) {
            console.log('搜尋', val);
            if (val === '') {
                this.filteredList = await this.getGames(this.platformKey);
                // console.log('search', this.filteredList)
                return;
            }
            const lowerCaseVal = val.toLowerCase(); // 將搜尋字串轉為小寫
            // this.filteredList = await this.getGames(this.platformKey)
            this.filteredList = this.filteredList.filter(item => {
                const title = item['title_' + this.lang]?.toLowerCase();
                const gametype = item.gametype?.toLowerCase();
                return title?.includes(lowerCaseVal) || gametype?.includes(lowerCaseVal);
            });
            // console.log('search', this.filteredList)
        },
        async filteredGames(val) {
            // console.log('filteredGames val', val)
            if (val === 'all') {
                this.filteredList = await this.getGames();
                return;
            }
            try {
                this.filteredList = await this.getGames(val);
                this.toggleClass(0);
            }
            catch (err) {
                console.error(`取得 ${val} 資料失敗`, err);
            }
            this.toggleClass(0);
        },
        async toggleClass(value) {
            // console.log('toggleClass value', value)
            const games = await this.getGames(this.platformKey);
            this.filteredList = games;
            // 點選全部 (0)
            if (value === 0) {
                this.filterClassNow = [0];
                this.toggleCondition(0);
                return;
            }
            // 點選其他時 → 移除 0
            const idx0 = this.filterClassNow.indexOf(0);
            if (idx0 !== -1)
                this.filterClassNow.splice(idx0, 1);
            // toggle 行為
            const idx = this.filterClassNow.indexOf(value);
            if (idx !== -1) {
                this.filterClassNow.splice(idx, 1); // 取消選擇
            }
            else {
                this.filterClassNow.push(value); // 新增
            }
            // 如果全部取消 → 回 0
            if (this.filterClassNow.length === 0) {
                this.filterClassNow = [0];
                this.toggleCondition(0);
                return;
            }
            this.filterCondition();
        },
        toggleCondition(val) {
            // 重複點回到全選
            if (val === this.filterConditionNow) {
                this.filterConditionNow = 0;
            }
            else {
                this.filterConditionNow = val;
            }
            // console.log('filterConditionNow', this.filterConditionNow)
            this.filterCondition();
        },
        handleHover() {
            this.errorMessage = '';
        },
        async filterCondition() {
            this.filteredList = await this.getGames(this.platformKey);
            const selectedKey = Array.from(new Set(this.filterClassesDynamic
                .filter(item => this.filterClassNow.includes(item.value))
                .map(item => item.key)));
            if (this.filterConditionNow === 0 && selectedKey.length === 0) {
                return;
            }
            if (selectedKey.length > 0) {
                this.filteredList = this.filteredList.filter(game => selectedKey.some(key => game.type.includes(key)));
            }
            // console.log('選擇的類型 key:', selectedKey)
            // this.filteredList = this.filteredList.filter(item => item.type?.includes(this.selectedClasses))
            const condition = this.filterConditionNow;
            // console.log(condition, this.filteredList)
            let result = [...this.filteredList];
            switch (condition) {
                case 0:
                    result = this.filteredList;
                    break;
                case 1:
                    result = this.filteredList.filter(game => game?.sw_support);
                    break;
                case 2:
                    result = this.filteredList.filter(game => game?.jackpot);
                    break;
                case 3:
                    result = this.filteredList.filter(game => this.hotList.includes(game.gametype));
                    break;
                case 4:
                    result = this.filteredList.filter(game => this.newList.includes(game.gametype));
                    break;
                case 5:
                    result = this.filteredList.filter(game => game?.is_free);
                    break;
            }
            this.filteredList = result;
            // console.log('filterCondition', this.filteredList)
        },
        toggleFlip(item) {
            this.errorMessage = '';
            this.$set(item, 'flipped', !item.flipped);
        },
        getDetail(item) {
            this.setCurrGame(item);
            this.ChangeDialog('GameDetail');
        },
        getRandomLoginName() {
            const list = this.lang === 'en' ? this.usdList : this.cnyList;
            const index = Math.floor(Math.random() * list.length);
            return list[index];
        },
        showGameArea() {
            toggleGameArea(this);
        },
        async goLink(gametype) {
            if (this.cantList.includes(gametype)) {
                this.errorMessage = '無法試玩';
                return;
            }
            if (gametype === 'SV41' || gametype === 'VIPL') {
                gametype = '800';
            }
            // 真人要改 gametype
            if (Object.prototype.hasOwnProperty.call(this.liveList, gametype)) {
                gametype = this.liveList[gametype];
            }
            const lang = this.lang === 'en' ? 3 : 1;
            const currcuency = this.lang === 'en' ? 'USD' : 'CNY';
            const loginname = this.getRandomLoginName();
            const sid = Math.floor(Math.random() * 9000000000000) + 1000000000000;
            try {
                const paramsStrArr = {
                    loginname: loginname,
                    sid: sid,
                    lang: lang,
                    gametype: gametype,
                    currcuency: currcuency
                };
                // console.log('paramsStrArr', paramsStrArr)
                // http://172.16.20.33:8081/getEncryptUrl
                const res = await fetch('https://docs.infopa.cc:8081/getEncryptUrl', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(paramsStrArr)
                });
                const data = await res.json();
                // console.log('data', data)
                if (res.ok) {
                    window.open(data.url, '_blank');
                }
            }
            catch (err) {
                console.error('Link 發生錯誤:', err);
            }
        }
    }
});
